import * as React from 'react';
import { observer } from 'mobx-react';
import { dateFormatter, TimeFormat, translationForMts } from 'easit--localization';
import "./../../../assets/img/chat/chat/user_blocked_off.png";
import "./../../../assets/img/chat/chat/user_blocked_on.png";

const assetRoot = "/img/";

export interface IMessageListItem {
    id: string;
    senderId: number;
    nickname: string;
    replyNickname: string;
    time: Date;
    message: string;
    isSenderBlocked: boolean;
}

export interface IMessageListProps {
    messages: IMessageListItem[];
    personId: number;
    hasNickname: boolean;
    isBlockChangeSendingMap: Map<string, number>;
    toggleBlockedPerson: (id: string, senderId: number) => void;
    setReplyTarget: (id: string, senderId: number, nickname: string) => void;
}

export const MessageList: React.StatelessComponent<IMessageListProps> = observer((props: IMessageListProps) => {

    const t = translationForMts();

    const renderMessage = (message: IMessageListItem) => {
        const visualUserLoggedAndDiff = props.personId != message.senderId && props.personId > 0 && props.hasNickname;
        const visualUserNotLoggedOrSame = props.personId == message.senderId || props.personId == 0 || !props.hasNickname;
        return (
            <div key={message.id} className="message-container">
                <span className="userinfo">
                    {visualUserLoggedAndDiff && <span className="icon block-user" >
                        <a onClick={() => { props.toggleBlockedPerson(message.id, message.senderId); }}>
                            <img src={`${assetRoot}user_blocked_${message.isSenderBlocked ? "on" : "off"}.png`}
                                title={message.isSenderBlocked ? t.chat_BlockedUser : t.chat_NonblockedUser}
                                className={props.isBlockChangeSendingMap.has(message.id.toString()) ? "blink_me" : null} />
                        </a>
                    </span>}
                    {
                        visualUserLoggedAndDiff &&
                        <span className={"name logged-diff-user"}>
                            <a onClick={() => { props.setReplyTarget(message.id, message.senderId, message.nickname) }}>
                                {message.nickname}
                            </a>
                        </span>}
                    {visualUserNotLoggedOrSame && <span className={"name"} >{message.nickname} </span>}
                    {message.replyNickname && <span className={"separator"} >&gt;</span>}
                    {message.replyNickname && <span className={"name to"}>{message.replyNickname}</span>}
                    <span className={"time"}>[{dateFormatter.formatTime(message.time, TimeFormat.HHMM)}]:</span>
                </span>
                <span className="text">
                    <span className="message" dangerouslySetInnerHTML={{ __html: message.message }}></span>
                </span>
            </div>
        )
    };

    return (
        <div className="messages">
            {props.messages.map(message => renderMessage(message))}
        </div>
    )
});
